import { Breadcrumb, Button, Card, Col, DatePicker, Input, message, Modal, Row } from 'antd';
import gql from 'graphql-tag';
import * as moment from 'moment';
import React, { Component } from 'react';
import { Mutation } from 'react-apollo';
import { Link } from 'react-router-dom';

const createCheckInMutation = gql`
  mutation createCheckIn($date: Date!, $serialId: String!, $userId: Int!) {
    createCheckIn(date: $date, userId: $userId, serialId: $serialId) {
      id
      userId
    }
  }
`;

interface State {
  isPopupConfirmVisible: boolean;
  checkInAt: moment.Moment;
  serialId?: string;
  userId?: number;
}

interface Props {}

export class DoCheckIn extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isPopupConfirmVisible: false,
      checkInAt: moment(),
    };
    this.onResetClick = this.onResetClick.bind(this);
  }

  onResetClick() {
    this.setState({
      serialId: undefined,
      userId: undefined,
    });
  }

  render() {
    return (
      <>
        <Breadcrumb style={{ marginBottom: 10, fontSize: 13 }}>
          <Breadcrumb.Item>
            <Link to={`/Home`}>首页</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>签到管理</Breadcrumb.Item>
        </Breadcrumb>
        <Mutation
          mutation={createCheckInMutation}
          variables={{ userId: this.state.userId, serialId: this.state.serialId, date: this.state.checkInAt.toDate() }}
        >
          {(createCheckIn, { loading, error }) => {
            return (
              <div>
                <Modal
                  width="60%"
                  title="确认签到"
                  visible={this.state.isPopupConfirmVisible}
                  onOk={async () => {
                    if (loading) {
                      return;
                    }
                    try {
                      await createCheckIn();
                      this.setState({
                        isPopupConfirmVisible: false,
                      });

                      message.success('签到成功');
                    } catch (e) {
                      message.error(e.message);
                    }
                  }}
                  onCancel={() => {
                    this.setState({ isPopupConfirmVisible: false });
                  }}
                >
                  <div>
                    <p>用户Id: {this.state.userId}</p>
                    <p>签到日期: {this.state.checkInAt.format()}</p>
                    <p>serialId: {this.state.serialId}</p>
                  </div>
                </Modal>
                <Card>
                  <Row gutter={24}>
                    <Col xs={24} md={24} lg={24} xl={8} xxl={8} style={{ marginTop: 10 }} title="签到日期">
                      <DatePicker
                        placeholder="签到日期"
                        value={this.state.checkInAt}
                        onChange={date => {
                          if (date !== null) {
                            this.setState({
                              checkInAt: date,
                            });
                          }
                        }}
                      />
                    </Col>
                    <Col xs={24} md={24} lg={24} xl={8} xxl={8} style={{ marginTop: 10 }} title="serialId">
                      <Input
                        allowClear
                        placeholder="serialId"
                        value={this.state.serialId}
                        onChange={e => {
                          this.setState({
                            serialId: e.target.value,
                          });
                        }}
                      />
                    </Col>
                    <Col xs={24} md={24} lg={24} xl={8} xxl={8} style={{ marginTop: 10 }} title="用户Id">
                      <Input
                        allowClear
                        placeholder="用户Id"
                        onChange={e => {
                          this.setState({
                            userId: Number(e.target.value),
                          });
                        }}
                      />
                    </Col>
                  </Row>
                  <Row type="flex" justify="end" style={{ marginTop: 10 }}>
                    <Button style={{ marginRight: 8 }} type="primary" onClick={this.onResetClick}>
                      重置
                    </Button>
                    <Button
                      icon="search"
                      type="primary"
                      htmlType="submit"
                      onClick={() => {
                        if (!this.state.serialId) {
                          message.error(`serialId不能为空`);
                          return;
                        }
                        if (!this.state.userId) {
                          message.error(`用户id不能为空`);
                          return;
                        }
                        this.setState({ isPopupConfirmVisible: true });
                      }}
                    >
                      提交
                    </Button>
                  </Row>
                </Card>
              </div>
            );
          }}
        </Mutation>
      </>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/checkIn/DoCheckIn.tsx